import createDataLakeSdkClient from '@svt/data-web-sdk';
import { isBrowser } from '../app/utils/environment';
import env from '../app/env';

function getValidationUrl() {
    try {
        const validationConfig = window.localStorage.getItem('validationConfig');

        if (validationConfig) {
            const { host, sessionId } = JSON.parse(validationConfig);

            return `${host}/api/session/${sessionId}`;
        }
    } catch (e) {
        return undefined;
    }

    return undefined;
}

function svtDataSdkClient() {
    if (!env.FLAG_ENABLE_DATA_LAKE || !isBrowser()) {
        return {
            getClientId: () => undefined,
            trackViewEvent: () => {},
            trackCustomEvent: () => {},
            trackNonInteractiveEvent: () => {},
        };
    }

    const eventApiUrl = getValidationUrl();
    const extraSdkConfig = eventApiUrl
        ? {
              eventApiUrl,
          }
        : {};

    return createDataLakeSdkClient({
        product: {
            name: 'svtplay',
            family: 'play',
            version: env.APP_VERSION,
        },
        config: {
            ...extraSdkConfig,
            env: env.HELIX_ENV,
        },
    });
}

export default svtDataSdkClient();
